import { Box, Button, CircularProgress, Select, Text, } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { participants } from "../../data";
import { selectedMenu, setHeaderText } from "../../redux/actions/actions";
import { loadReports } from "../../redux/api_calls/apiCalls";
import Download from "./DownloadReport";
import ItemsList from "./ItemsList";
import VideoList from "./VideoList";

// import exportFromJSON from 'export-from-json'

export default function Reports() {
    // const [isLoading, setIsLoading] = useState(false)
    const headerText = useSelector(state => state.headerState.headerText)
    const { reportsData, isLoading } = useSelector(state => state.reportsState)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setHeaderText('Analytics'))
        dispatch(selectedMenu(6))
        dispatch(loadReports())
    }, [dispatch])

    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >

            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
            </Box>


            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='flex-start'
                w='80%'
                mb='3rem'
            >
                <Box
                    w='30%'
                    d='flex'
                    flexDir='column'
                >
                    <Text
                        fontSize='15px'
                        color='#222222'
                        fontWeight='800'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        mb='1rem'
                    >
                        TOP PERFORMING COURSES
                    </Text>
                    {
                        isLoading ? <CircularProgress size='15px' isIndeterminate /> :
                            <ItemsList items={reportsData?.top_performing_courses || []} />
                    }
                </Box>

                <Box
                    w='30%'
                    d='flex'
                    flexDir='column'
                >
                    <Text
                        fontSize='15px'
                        color='#222222'
                        fontWeight='800'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        mb='1rem'
                    >
                        TOP PERFORMING QUIZZES
                    </Text>{
                        isLoading ? <CircularProgress size='15px' isIndeterminate /> :
                            <ItemsList items={reportsData?.top_performing_quizzes || []} />
                    }
                </Box>

                <Box
                    w='30%'
                    d='flex'
                    flexDir='column'
                    height='100%'
                >
                    <Text
                        fontSize='15px'
                        color='#222222'
                        fontWeight='800'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        mb='1rem'
                    >
                        CONDUCTED LIVE CLASSES
                    </Text>
                    <Box w='100%' d='flex' flexDir='column' flex='1' >
                        {
                            isLoading ?
                                <Box w='100%' d='flex' justifyContent='center' alignItems='center' backgroundColor='transparent'>
                                    <CircularProgress size='15px' isIndeterminate />
                                </Box> :
                                <VideoList />
                        }
                    </Box>

                </Box>

            </Box>

            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='center'
                w='80%'
                mb='2rem'
            >
                <Select
                    fontSize='20px'
                    color='#999999'
                    fontWeight='400'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    placeholder='Course'
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    bg='#ffffff'
                    borderRadius='13px'
                    height='50px'
                    id='courses'
                    width='42.5%'
                >
                    <option val={'1'}>Courses List will appear here</option>
                </Select>
                <Select
                    fontSize='20px'
                    color='#999999'
                    fontWeight='400'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    placeholder='Quiz'
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    bg='#ffffff'
                    borderRadius='13px'
                    height='50px'
                    id='quizzes'
                    width='42.5%'
                >
                    <option val={'1'}>Quizzes List will appear here</option>
                </Select>
                <Button
                    fontSize='16px'
                    color='#ffffff'
                    fontWeight='800'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    placeholder='Quiz'
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    bg='#cebc1f'
                    padding='12px 35px'
                    borderRadius='10px'
                    height='44px'
                    _hover={{ bg: '#b9a91a' }}
                >
                    Start
                </Button>
            </Box>
            <Box
                w='80%'
                d='flex'
                justifyContent='space-between'
                alignItems='center'
                mb='1rem'
                px='1rem'
            >
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%'>PARTICIPANTS</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='12.5%' textAlign='center'>COMPLETED SESSIONS</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='10%' textAlign='center'>QUIZ COMPLETED</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%' textAlign='center'>LIVE CLASS ATTENDED</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='7.5%' textAlign='center'>SCORE LEVEL</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='10%' textAlign='center'>POINTS EARNED</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='10%' textAlign='center'>CERTIFICATES</Text>
            </Box>
            <Box
                w='80%'
                border='1px solid rgba(0, 0, 0, 0.1)'
                boxShadow='0px 4px 10px rgba(0, 0, 0, 0.1)'
                borderRadius='10px'
                px='1rem'
                mb='1rem'
            >
                {
                    participants.map((user, idx) => <Box
                        w='100%'
                        d='flex'
                        justifyContent='space-between'
                        alignItems='center'
                        py='1rem'
                        fontSize='15px'
                        color='#000000'
                        fontWeight='600'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        borderBottom='1px solid rgba(0, 0, 0, 0.05)'
                        key={idx}
                    >
                        <Text width='15%'>{user.name}</Text>
                        <Text width='12.5%' textAlign='center'>{user.completed_sessions}</Text>
                        <Text width='10%' textAlign='center'>{user.quiz_completed}</Text>
                        <Text width='15%' textAlign='center'>{user.live_class_attended}</Text>
                        <Text width='7.5%' textAlign='center'>{user.score_level}</Text>
                        <Text width='10%' textAlign='center'>{user.points_earned}</Text>
                        <Text width='10%' textAlign='center'>{user.certificates}</Text>
                    </Box>
                    )
                }
            </Box>
            <Box
                w='80%'
                d='flex'
                justifyContent='center'
                alignItems='center'
                mb='1rem'
            >
                <Button
                    color='#00000099'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='700'
                    fontSize={["12px", "14px", "16px", "18px"]}
                    border='2px solid rgba(0, 0, 0, 0.1)'
                    boxShadow='0px 3px 16px rgba(0, 0, 0, 0.1)'
                    borderRadius='xl'
                    py={['0.5rem', '0.75rem', '1rem', '1.5rem']}
                    px={['0.75rem', '1rem', '1.5rem', '2rem']}
                    m='2rem'
                    bg='#ffffff'
                >
                    Load More...
                </Button>
                <Box>
                    {/* <Button
                        as="span"
                        fontSize='16px'
                        color='#ffffff'
                        fontWeight='800'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        placeholder='Quiz'
                        border='1px solid rgba(0, 0, 0, 0.1)'
                        bg='#cebc1f'
                        padding='12px 35px'
                        borderRadius='10px'
                        height='44px'
                        _hover={{ bg: '#b9a91a' }}
                        // onClick={downloadHandler}
                        cursor='pointer'
                    >
                        Download
                    </Button> */}
                    <Box
                        fontSize='18px'
                        color='#ffffff'
                        fontWeight='800'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        placeholder='Quiz'
                        border='1px solid rgba(0, 0, 0, 0.1)'
                        bg='#cebc1f'
                        // padding='12px 35px'
                        justifyContent='center'
                        alignItems='center'
                        display='flex'
                        borderRadius='10px'
                        height='44px'
                        _hover={{ bg: '#b9a91a' }}
                        // onClick={downloadHandler}
                        cursor='pointer'
                    >
                        <Download />
                    </Box>
                </Box>
            </Box>

        </Box>
    )
}